import { AppRoutes } from 'config';
import { joinRoutes } from 'utils/helpers';
import { EventProfitAndLossLtlDetail } from 'store/api/event/types';

const { Transfers, StockOrders } = AppRoutes.Inventory;

export const template = '88px 112px repeat(2, 1fr) 96px';
export const titles = ['Date', 'Type', 'Carrier', 'LTL Invoice #', 'Amount'];

export const ltlSourceLabels: Record<
  EventProfitAndLossLtlDetail['source'],
  string
> = {
  stockOrder: 'Stock order',
  stockTransfer: 'Stock transfer',
};

export const getLtlDetailsRoute = ({
  id,
  source,
}: Pick<EventProfitAndLossLtlDetail, 'id' | 'source'>) =>
  source === 'stockOrder'
    ? joinRoutes([StockOrders.Home, StockOrders.Details], { id })
    : joinRoutes([Transfers.Home, Transfers.Details], { id });

export const getLtlTotal = (ltlDetails: EventProfitAndLossLtlDetail[] = []) =>
  ltlDetails.reduce((acc, value) => acc + Number(value?.amount || 0), 0);
